import { render, staticRenderFns } from "./ExamDataLayout.vue?vue&type=template&id=3d892d44&scoped=true&"
import script from "./ExamDataLayout.vue?vue&type=script&lang=js&"
export * from "./ExamDataLayout.vue?vue&type=script&lang=js&"
import style0 from "./ExamDataLayout.vue?vue&type=style&index=0&id=3d892d44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d892d44",
  null
  
)

export default component.exports